import { axios } from 'lib/axios';
import { useQuery } from '@tanstack/react-query';


const getBySlugRequest = async (type, slug) => {
  try {
    return await axios.get(`/api/profile/${type}/${slug}`);
  } catch (error) {
    if (error?.response?.data.description === "record not found") {
      throw new Error("Object doesn't exist");
    }
    
    throw new Error("You don't have permissions to see this object");
  }
};

export const useGetCompanyBySlug = (type, slug, config = {}) => {
  const configOptions = {select: ({ data }) => data, retry: false, ...config}
  const isEnabled = (config?.enabled ?? true) && !!slug && typeof slug === 'string';

  return useQuery({
    queryKey: [`companyProfile-${slug}`],
    queryFn: () => getBySlugRequest(type, slug),
    ...configOptions,
    enabled: isEnabled,
  });
};